<template>
  <Instance
    instance="corporation"
    instance-name="Corporation"
    :create="(d) => corporation.create(d)"
    :delete="(d) => corporation.remove(d)"
    :update="(d) => corporation.update(d)"
    :get="(d) => corporation.get(d)"
    :upsert="upsert"
    :columns="columns"
    :header="false"
    headerBg="#ffffff"
  />
</template>

<script>
import { BIconPencil } from 'bootstrap-vue';

import Instance from '../../../CRUD/instance';
import api from '../../../../api';

export default {
  title: 'Corporation',
  components: { Instance },
  data() {
    return {
      corporation: api.corporation,
      upsert: [
        { value: 'name', name: 'Name', required: true },
        { value: 'cid', name: 'ID', required: true },
        { value: 'address', name: 'Address' },
      ],
    };
  },
  methods: {
    columns({ editInstance }) {
      return [
        {
          field: 'check',
          key: '1',
          type: 'checkbox',
          title: '',
          width: 50,
          align: 'center',
        },
        {
          field: 'cid',
          title: this.$translate('ID'),
          key: '11',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'name',
          title: this.$translate('Name'),
          key: '3',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'address',
          title: this.$translate('Address'),
          key: '4',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'actions',
          title: '',
          key: '10',
          renderBodyCell: ({ row }) => {
            return (
              <div class="action-block">
                <div class="details-action" on-click={() => editInstance(row)}>
                  <BIconPencil />
                </div>
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>
